<su-headline h="h1" skin="primary" [hidden]="useLegacyUi && filledForm">{{
  headline
}}</su-headline>

<!-- Dropdown-Variante (environment.useLegacyUserPermissionsUi === true) -->
<ng-container *ngIf="useLegacyUi">
  <su-card [card]="legacyCardUser" [hidden]="filledForm">
    <div card-content>
      <br />
      <formly-form [form]="form" [fields]="formFields" [model]="formModel">
      </formly-form>
    </div>
  </su-card>

  <su-headline *ngIf="filledForm" h="h1" skin="primary">{{
    'user.request.summary.title_permission' | translate
  }}</su-headline>
  <div class="description" *ngIf="filledForm">
    <p
      [innerText]="'user.request.summary.p__info_summary' | translate"
      class="confirm-value"></p>
  </div>
  <br />
  <su-card [card]="cardConfirm" *ngIf="filledForm">
    <div card-content data-debug="form-confirm">
      <ng-container>
        <div class="confirm-container">
          <div>
            <div class="confirm-label">
              <span>
                {{ 'user.request.summary.label__requestType' | translate }}:
              </span>
            </div>
            <div>
              <span
                class="confirm-value"
                *ngIf="formModel['userData']['isRequestForOwnUser']">
                {{ 'user.request.permissions.own_user' | translate }}
              </span>
              <span
                class="confirm-value"
                *ngIf="!formModel['userData']['isRequestForOwnUser']">
                {{ 'user.request.permissions.external_user' | translate }}
              </span>
            </div>
          </div>

          <div>
            <div class="confirm-label">
              <span>
                {{ 'user.request.summary.label__email' | translate }}:
              </span>
            </div>
            <div>
              <span class="confirm-value" *ngIf="formModel['userData']['email']">
                {{ formModel['userData']['email'] }}
              </span>
              <span
                class="confirm-value"
                *ngIf="!formModel['userData']['email']">
                --
              </span>
            </div>
          </div>

          <div>
            <div class="confirm-label">
              <span>
                {{ 'user.request.summary.label__requestedRoles' | translate }}:
              </span>
            </div>
            <div
              *ngIf="
                formModel['userData']['roles']
                  | exceptFilterPipe: currentRoles : 'id' as addedRoles
              ">
              <ul *ngIf="addedRoles.length > 0">
                <li class="confirm-value" *ngFor="let item of addedRoles">
                  {{ item.description }}
                </li>
              </ul>
              <span class="confirm-value" *ngIf="addedRoles.length === 0">
                --
              </span>
            </div>
          </div>
        </div>

        <div *ngIf="isRequestForOwnUser">
          <div class="confirm-label">
            <span>
              {{ 'user.request.summary.label__removedRoles' | translate }}:
            </span>
          </div>
          <div
            *ngIf="
              currentRoles
                | exceptFilterPipe: formModel['userData']['roles'] : 'id' as removedRoles
            ">
            <ul *ngIf="removedRoles.length > 0">
              <li class="confirm-value" *ngFor="let item of removedRoles">
                {{ item.description }}
              </li>
            </ul>
            <span class="confirm-value" *ngIf="removedRoles.length === 0">
              --
            </span>
          </div>
        </div>
      </ng-container>

      <form (ngSubmit)="requestRoles()">
        <div class="confirm-buttons">
          <su-button
            [skin]="'primary'"
            [icon]="'arrow-left'"
            [label]="'ticket.create.confirm.button__back_to_edit' | translate"
            (onClick)="discardSumUpForm()">
          </su-button>
          <su-button
            id="buttonSendInConfirmForm"
            type="submit"
            [skin]="'accent'"
            [icon]="'paper-plane'"
            [label]="'ticket.create.confirm.button__send' | translate"
            [disabled]="isSubmitted">
          </su-button>
        </div>
      </form>
    </div>
  </su-card>
</ng-container>

<!-- Variante mit Button, Modal und Rollen-Tabelle -->
<ng-container *ngIf="!useLegacyUi">
  <formly-form [form]="form" [fields]="formFields" [model]="formModel">
  </formly-form>

  <div
    style="
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      width: 100%;
      margin-bottom: 25px;
    ">
    <su-button
      skin="primary"
      icon="plus"
      [disabled]="!selectedEmployee"
      [label]="
        'user.request.permissions.assignment.button__select_permission'
          | translate
      "
      (click)="openAssignRoleDialog()">
    </su-button>
    <br /><br />

    <mtx-grid
      #grid
      [columns]="assignedRolesColumns"
      [data]="assignedRoles"
      [rowClassFormatter]="assignedRoleRowClassFormatter"
      [pageOnFront]="true"
      [pageSizeOptions]="[5, 10, 25, 50, 100]"
      [rowStriped]="true"
      [rowHover]="true"
      [cellSelectable]="false"
      [showSidebar]="true"
      [hideRowSelectionCheckbox]="false"
      [showColumnMenuButton]="false">
    </mtx-grid>

    <br />
  </div>
</ng-container>

<ng-template #extendTemplate let-row let-index="index" let-col="colDef">
  <su-button
    *ngIf="isPersistedRole(row) && isRoleExtendable(row.validUntil)"
    skin="primary"
    icon="check"
    [matTooltip]="
      'user.request.permissions.assignment.table.extend' | translate
    "
    (click)="onExtendRole(row)"
    [ariaLabel]="
      'user.request.permissions.assignment.table.extend' | translate
    ">
  </su-button>
</ng-template>

<ng-template #endTemplate let-row let-index="index" let-col="colDef">
  <su-button
    *ngIf="isPersistedRole(row) && !row.isExpired"
    skin="secondary"
    icon="x"
    [matTooltip]="'user.request.permissions.assignment.table.end' | translate"
    (click)="onEndRole(row)"
    [ariaLabel]="'user.request.permissions.assignment.table.end' | translate">
  </su-button>
</ng-template>

<app-spinner-overlay
  [show]="loading"
  [label]="loadingMessage"></app-spinner-overlay>
